import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['content', 'toggler']

  static values = {
    contentVisible: Boolean
  }

  connect() {
    if (!this.hasContentVisibleValue) {
      this.contentVisibleValue = false
    }

    this.togglerTarget.addEventListener('click', this.toggleContent.bind(this))
  }

  disconnect() {
    this.togglerTarget.removeEventListener('click', this.toggleContent.bind(this))
  }

  contentVisibleValueChanged(current, old) {
    if (this.hasContentVisibleValue && current !== old) {
      this.updateContentVisibility()
    }
  }

  toggleContent(event) {
    this.contentVisibleValue = !this.contentVisibleValue
  }

  showContent(event) {
    this.contentVisibleValue = true
  }

  updateContentVisibility() {
    const getTargetAttr = (target, attrName) => {
      const attribute = `data-${this.identifier}-${attrName}-attr`
      return target.getAttribute(attribute)
    }

    if (this.contentTarget) {
      let togglerText = null

      if (this.contentVisibleValue) {
        this.contentTargets.forEach((content) => {
          content.removeAttribute('hidden')
        })
        togglerText = getTargetAttr(this.togglerTarget, 'text-when-content-visible')
      } else {
        this.contentTargets.forEach((content) => {
          content.setAttribute('hidden', 'hidden')
        })
        togglerText = getTargetAttr(this.togglerTarget, 'text-when-content-not-visible')
      }

      if (togglerText !== null) {
        this.togglerTarget.innerHTML = togglerText
      }
    }
  }
}
